import { Component, OnInit } from '@angular/core';
import { EmergencyService } from 'src/app/core/services/emergency.service';

@Component({
  selector: 'app-emergency-command',
  templateUrl: './emergency-command.component.html',
  styleUrls: ['./emergency-command.component.scss'],
})
export class EmergencyCommandComponent implements OnInit {
  constructor(public emergencyService: EmergencyService) {}

  items: any[] = [];
  circularProgressiveWait: boolean = false;
  errorMessage: string = '';

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.circularProgressiveWait = true;
    this.errorMessage = '';
    this.emergencyService.getEmergencyCommands().subscribe({
      next: (data) => {
        this.items = data;
        this.circularProgressiveWait = false;
      },
      error: (err) => {
        this.circularProgressiveWait = false;
        this.errorMessage =
          err?.name === 'TimeoutError'
            ? 'O serviço não respondeu no tempo esperado. Tente novamente.'
            : 'Erro ao carregar os dados. Tente novamente.';
      },
    });
  }

  exportCsv(): void {
    const headers = ['Command ID', 'Serial', 'Fabricante', 'Sistema', 'Data Envio', 'Placa', 'Tipo Evento', 'Ignicao', 'Data/Hora Posicao', 'Dias', 'Ativo', 'Hardware', 'Firmware', 'Marca', 'Modelo'];
    const rows = this.items.map(item => [
      item.commandId,
      item.serial,
      item.fabricante,
      item.sistema,
      item.dataEnvioDate ? new Date(item.dataEnvioDate).toLocaleString('pt-BR') : '',
      item.lastPosition?.placa ?? '',
      item.lastPosition?.tipoEvento ?? '',
      item.lastPosition?.ignicao ?? '',
      item.lastPosition?.datahora ?? '',
      item.dias,
      item.installation?.isActive ? 'Sim' : 'Não',
      item.installation?.deviceName ?? '',
      item.lastPosition?.versaoFirmware ?? '',
      item.installation?.brand ?? '',
      item.installation?.model ?? '',
    ]);
    this.downloadCsv('comandos-emergencia.csv', headers, rows);
  }

  private downloadCsv(filename: string, headers: string[], rows: any[][]): void {
    const escape = (v: any) => `"${String(v ?? '').replace(/"/g, '""')}"`;
    const csv = [headers.map(escape).join(';'), ...rows.map(r => r.map(escape).join(';'))].join('\n');
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  }
}
